"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    acceptInvite: {
        path: "/accept-invite/:inviteId",
    },
    passwordReset: {
        path: "/password-reset",
    },
    passwordResetRequest: {
        path: "/password-reset/:requestId",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9yb3V0aW5nL3VzZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUV6QixRQUFBLE1BQU0sR0FBRyxJQUFBLG1CQUFXLEVBQUM7SUFDaEMsWUFBWSxFQUFFO1FBQ1osSUFBSSxFQUFFLDBCQUEwQjtLQUNqQztJQUNELGFBQWEsRUFBRTtRQUNiLElBQUksRUFBRSxpQkFBaUI7S0FDeEI7SUFDRCxvQkFBb0IsRUFBRTtRQUNwQixJQUFJLEVBQUUsNEJBQTRCO0tBQ25DO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBhY2NlcHRJbnZpdGU6IHtcbiAgICBwYXRoOiBcIi9hY2NlcHQtaW52aXRlLzppbnZpdGVJZFwiLFxuICB9LFxuICBwYXNzd29yZFJlc2V0OiB7XG4gICAgcGF0aDogXCIvcGFzc3dvcmQtcmVzZXRcIixcbiAgfSxcbiAgcGFzc3dvcmRSZXNldFJlcXVlc3Q6IHtcbiAgICBwYXRoOiBcIi9wYXNzd29yZC1yZXNldC86cmVxdWVzdElkXCIsXG4gIH0sXG59KTtcbiJdfQ==